import React, {Component} from 'react';
import {Route, withRouter} from 'react-router-dom';
import AdminMenu from './AdminMenu';
import Menu from '../Menu/Menu';
import Info from './Info';
import LangConf from './LangConf';
import UserConf from './User/UserConf';
import TabConf from './Tab/TabConf';
import PointsConf from './Point/PointsConf';
import BackupDB from './Backup/BackupDB';
import BackupImg from './Backup/BackupImg';

class Admin extends Component {
  constructor(props){
    super(props);
    this.state = {
      lastscreen: "",
      screen: "adminmenu",
      icons: [],
      UsrCnf: false,
      UsrCnfPass: false,
      UsrCnfDel: false,
      TabCnf: false,
      TabCnfDel: false,
      PointCnf: false,
      PointCnfDel: false,
      DBfileBk: false,
      ImgfileBk: false,
      SelectedUsr: "",
      SelectedTab: "",
      menutype: "admin",
      viewp: true
    }
  }

  componentWillReceiveProps() {
    let path = this.props.history.location.pathname;
    switch (path){
      case "/home/admin":
        this.setState({screen: "adminmenu", menutype: "admin", icons: []});
        break;
      case "/home/admin/usr":
        this.setState({screen: "UsrCnf", icons: ["create"], menutype: "admin"});
        break;
      case "/home/admin/tabs":
        this.setState({screen: "TabCnf", icons: ["create"], menutype: "admin"});
        break;
      case "/home/admin/vis":
        this.setState({screen: "PointCnf", icons: ["create"], menutype: "admin"});
        break;
      case "/home/admin/backupbd":
        this.setState({screen: "BackupBD"});
        break;
      case "/home/admin/backupimg":
        this.setState({screen: "BackupImg"});
        break;
      default:
        break;
    }
    //console.log(/\/home\/admin\/usr\/[0-9]/.test(path));
  }
  changeScreen = (name = "") => {
    switch(name) {
      case "LngCnf":
        this.setState({screen: name});
        break;
      case "UsrCnf":
        this.setState({screen: name, icons: ["create"]});
        break;
      case "SelectedUsr":
        this.setState({
          screen: name, 
          menutype: name,
        })
        break;
      case "TabCnf":
        this.setState({
          screen: name, 
          icons: ["addTab"],
          menutype: name
        });
        break;
      case "SelectedTab":
        this.setState({
          screen: name, 
          icons: ["trashtab"],
          menutype: name
        });
        break;
      case "PointCnf":
        this.setState({
          screen: name, 
          icons: ["addVis"],
          menutype: name
        });
        break;
      case "BackupBD":
        this.setState({
          screen: name, 
        });
        break;
      case "BackupImg":
        this.setState({
          screen: name, 
        });
        break;
      default:
        break;
    }
  }
  selectUser = (usr) => {
    this.setState({
      screen: "SelectedUsr", 
      SelectedUsr: usr, 
      menutype: "SelectedUsr",
    })
  }
  selectTab = (tab) => {
    this.setState({
      screen: "SelectedTab", 
      SelectedTab: tab, 
      menutype: "SelectedTab",
    })
  }
  openMod = (modal) => {
    this.state[modal]
    ? this.setState({[modal]: false})
    : this.setState({[modal]: true})
  }
  render() {
    return (
      <div id="admin-out">
        <Route path='/home/admin' exact render={() => {
          return (
            <div className="admin">
              <AdminMenu 
                logOut={this.props.logOut}
                language={this.props.language}
                changeScreen={this.changeScreen}
                viewp={this.state.viewp}
                loged={this.props.loged}/>
              <Info 
                language={this.props.language}
                version={this.props.version}/>
            </div>
          )
        }}/>
        <Route 
          path='/home/admin/lang' exact  
          render={() => {
          return (
            <div className="admin">
              <LangConf 
                loged={this.props.loged}
                changeLang={this.props.changeLang}
                changeScreen={this.changeScreen}/>
            </div>
          )
        }}/>
        <Route 
          path='/home/admin/usr' 
          render={() => {
          return (
            <div className="admin">
              <UserConf
                logOut={this.props.logOut}
                tableros={this.props.tableros}
                language={this.props.language}
                url={this.props.url}
                tkn={this.props.tkn}
                changeScreen={this.changeScreen}
                openMod={this.state.UsrCnf}
                openModPass={this.state.UsrCnfPass}
                openModDel={this.state.UsrCnfDel}
                selectUser={this.selectUser}
                SelectedUsr={this.state.SelectedUsr}
                msg={this.props.msg}
                funct={this.openMod}
              />
            </div>
          )
        }}/>
        <Route path='/home/admin/tabs' render={() => {
          return (
            <div className="admin">
              <TabConf 
                loged={this.props.loged}
                url={this.props.url}
                language={this.props.language}
                funct={this.openMod}
                openMod={this.state.TabCnf}
                openModDel={this.state.TabCnfDel}
                selectTab={this.selectTab}
                selectedTab={this.state.SelectedTab}
                tkn={this.props.tkn}
                msg={this.props.msg}
                changeScreen={this.changeScreen}/>
            </div>
          )
        }}/>
        <Route path='/home/admin/vis' exact render={() => {
          return (
            <div className="admin">
              <PointsConf 
                logOut={this.props.logOut}
                url={this.props.url}
                tkn={this.props.tkn}
                funct={this.openMod}
                language={this.props.language}
                openMod={this.state.PointCnf}
                openModDel={this.state.PointCnfDel}
                msg={this.props.msg}
                changeScreen={this.changeScreen}/>
            </div>
          )
        }}/>
        <Route path='/home/admin/backupbd' exact render={() => {
          return (
            <div className="admin">
              <BackupDB
                logOut={this.props.logOut}
                language={this.props.language}
                url={this.props.url}
                tkn={this.props.tkn}
                msg={this.props.msg}
                openMod={this.state.DBfileBk}
                funct={this.openMod}
              />
            </div>
          )
        }}/>
        <Route path='/home/admin/backupimg' exact render={() => {
          return (
            <div className="admin">
              <BackupImg
                logOut={this.props.logOut}
                language={this.props.language}
                url={this.props.url}
                tkn={this.props.tkn}
                msg={this.props.msg}
                openMod={this.state.ImgfileBk}
                funct={this.openMod}/>
            </div>
          )
        }}/>
        <Menu 
          type={this.state.menutype}
          usr={this.state.SelectedUsr}
          tab={this.state.SelectedTab}
          icons={this.state.icons} 
          language={this.props.language}
          screen={this.state.screen}
          openMod={this.openMod}/>
      </div>
    )
  }
}

export default withRouter(Admin);


// WEBPACK FOOTER //
// ./src/Components/Admin/Admin.js